import { createContext, ReactNode, useContext } from 'react';
import { useDisplay } from '~src/hooks/useDisplay';

import { DeviceType } from '~src/model';

export type DisplayContext = {
  leadOrigin?: string;
  leadOriginLoading?: boolean;

  deviceType: DeviceType;
  isMobile: boolean;
  breakpointWidth: number;

  width: number;
  height: number;
};

const DisplayContext = createContext<DisplayContext>({
  deviceType: 'DESKTOP',
  width: 0,
  height: 0,
  breakpointWidth: 0,
  isMobile: false,
  leadOrigin: undefined,
  leadOriginLoading: false,
});

export const DisplayContextProvider = ({ children }: { children?: ReactNode }) => {
  const displayValues = useDisplay();

  return <DisplayContext.Provider {...{ value: displayValues }}>{children}</DisplayContext.Provider>;
};

export const useDisplayContext = () => useContext<DisplayContext>(DisplayContext);
